export default __webpack_public_path__ + "static/P_SearchThumb_IN-8415WQHD-69c303c01f631f35f1c148eccefde6d5.webp";